import { useAppSelector } from 'app';

/**
 * Returns true when the current session is an Ideal DMS user on a hosted dealer.
 * Used to gate features that should only apply to Ideal hosted dealers.
 */
export const useIsIdealHostedDealer = (): boolean => {
  const isHostedDealer = useAppSelector((state) => state.user.isHosted);
  return isHostedDealer && localStorage.getItem('Login_Source')?.toString() === 'DMS_IDEAL';
};

export default useIsIdealHostedDealer;
